import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import fontAdjustments from "./modules/fontAdjustments";
import modules from "./modules/index";
import mutations from "./mutations";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

let default_state = {
    layout: {
        navPos: "left", //top, bottom, left, right, false
        toolbar: "top", //top, bottom, false
        footer: true, //above, below, false
        boxed: false, //true, false
        roundedCorners: false, //true, false
        viewAnimation: "fade-top" // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
    },
    splashScreen: true,
    config: null,
    enums: null,
    logged: false,
    user: null,
    csrf: null,
    current_corporation: null,
    current_community: null,
    preset_data_fetched: false,
    sizes: {
        data: []
    },
    digital_files: {
        data: []
    },
    printed_extras: {
        data: []
    },
    corporations: {
        data: [],
        meta: {
            include: "location,logo,discounts"
        }
    },
    communities: {
        data: [],
        meta: {
            include: "locations,logo,address,custom_charges,coupon"
        }
    },
    users: {
        data: [],
        meta: {
            include: "roles"
        }
    },
    orders: {
        // pending orders
        data: [],
        meta: {
            include:
                "statuses.updater,community.locations,community.corporation,creator,tenant,latest_status,items.sizes.size"
        }
    },
    notifications: {
        data: [],
        meta: {
            pagination: null
        }
    },
    cart: {
        orders: [],
        shipping_in_progress: false
    },
    cart_tax: null,
    loading_cart_tax: false,
    discounts: {
        data: []
    },
    current_order: null,
    prices: {
        data: []
    },
    states: {
        data: []
    },
    require_agree_policy: false,
    active_coupon: null,
    deleted_events: {
        // deleted_events
        data: [],
        meta: {
            include: "event,user"
        }
    },
    handling_charge: null,
    loading_handling_charge: false
};

export default new Vuex.Store({
    strict: debug,
    state: {
        ...default_state,
        ...window.App.state
    },
    mutations,
    actions,
    getters,
    modules: {
        ...modules,
        fontAdjustments
    }
});
